import React, { useEffect, useRef } from "react";
import FileOpenIcon from "@material-ui/icons/OpenInNew";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import IconButton from "@material-ui/core/IconButton";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import UploadMedia from "features/MediaLibrary/components/UploadMediaInput";
import { is_empty } from "features/Common/utils/common.utils";
import ExlyLoader from "ui/modules/ExlyLoader";
import {
  max_uploadable_file_size_in_mb,
  max_uploadable_files_limit,
} from "./InitiateDisputeModal.constants";
import { useInitiateDispute } from "./useInitiateDispute";
import { useDisputeModal } from "./store/useDisputeModal";
import { getSignedS3DownlaodURL } from "./utils/InitiateDisputeModal.utils";

export const InitiateDisputeModal = ({ value }) => {
  const { selectedRecords } = value;

  const record = Object.values(selectedRecords)[0];
  const inputRef = useRef();
  const open = useDisputeModal((state) => state.isOpenInitiateDisputeModal);
  const files = useDisputeModal((state) => state.files);
  const isUploaded = useDisputeModal((state) => state.isUploaded);
  const setIsUploaded = useDisputeModal((state) => state.setIsUploaded);
  const {
    loading,
    onChangeFileInput,
    handleDelete,
    handleClose,
    handleDisputeDocumentUpload,
  } = useInitiateDispute();

  const filesContainerRef = useRef(null);

  useEffect(() => {
    requestAnimationFrame(() => {
      if (
        !is_empty(files) &&
        filesContainerRef.current?.children.length === files.length
      ) {
        setIsUploaded(true);
      } else {
        setIsUploaded(false);
      }
    });
  }, [files]);

  const onDeleteClick = ({ index }) => {
    handleDelete(index);
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  return (
    <ExlyModal
      title="Resolve Dispute"
      open={open}
      onClose={() => handleClose()}
      onPrimaryBtnClick={
        is_empty(files)
          ? () => inputRef.current.click()
          : isUploaded
          ? () => handleDisputeDocumentUpload(record)
          : () => {}
      }
      primaryBtnText={!isUploaded ? "Upload" : "Submit Documents"}
      showSecondaryBtn={false}
      modal_props={{
        modalPaperClassName: "!tw-min-w-[450px]",
      }}
    >
      <div className="tw-pt-[20px] tw-pb-[10px]">
        <label className="tw-font-bold tw-text-[#493ab1] tw-pl-[8px] tw-pb-[5px] !tw-m-0">
          Reason for dispute
        </label>
        <div className="tw-bg-gray-100 tw-border tw-shadow-sm tw-rounded-lg tw-p-3 tw-text-gray-700 tw-font-medium">
          {record?.dispute_reason}
        </div>
        <UploadMedia
          reference={inputRef}
          inputName="disputeDocuments"
          handleInputChange={onChangeFileInput}
        />
        {!is_empty(files) ? (
          <>
            <div className="tw-mt-[40px] tw-flex tw-justify-between tw-items-center">
              <label className="tw-font-bold tw-text-[#493ab1] tw-pl-[4px] tw-pb-[5px] !tw-m-0">
                Upload Documents
              </label>
              <button
                className={`tw-px-[12px] tw-py-[6px] !tw-bg-[#493AB1] tw-text-white tw-rounded-md tw-font-medium hover:tw-bg-[#3A29B8] tw-transition tw-mr-[5px] ${
                  files.length === 5 && "tw-opacity-50 tw-cursor-not-allowed"
                }`}
                onClick={() => inputRef.current.click()}
                disabled={files.length === 5}
              >
                Upload
              </button>
            </div>
            {!loading ? (
              <div
                ref={filesContainerRef}
                className="tw-mt-[10px] tw-grid tw-text-center tw-pt-[10px] tw-px-[10px]"
              >
                {files?.map((file, index) => {
                  return (
                    <div
                      key={`${file?.id}-${index + 1}`}
                      className="tw-flex tw-justify-between tw-gap-[15px]"
                    >
                      <div className="tw-flex tw-items-center tw-gap-[15px]">
                        <span className="tw-w-[20px] tw-flex tw-items-center">
                          {index + 1}.
                        </span>
                        <span className="tw-w-[250px] tw-text-left tw-ml-[10px] tw-truncate">
                          {file.name}
                        </span>
                      </div>
                      <div>
                        <IconButton
                          className="!tw-p-[5px]"
                          onClick={() =>
                            getSignedS3DownlaodURL(file, "fileLocation")
                          }
                        >
                          <FileOpenIcon className="tw-text-[#493AB1]" />
                        </IconButton>
                        <IconButton
                          className="!tw-p-[5px]"
                          onClick={() => onDeleteClick({ index })}
                        >
                          <DeleteOutlineIcon className="tw-text-[#bf2600]" />
                        </IconButton>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : null}
          </>
        ) : null}
        {loading && (
          <div className="tw-flex tw-justify-center tw-mt-[30px] tw-mb-[20px]">
            <ExlyLoader
              className="tw-max-w-[14px] tw-max-h-[14px] tw-mb-[30px] tw-mr-[30px]"
              showText={false}
            />
          </div>
        )}
        <div
          className={`tw-flex tw-bg-[#FFF7DA] tw-leading-[14.32px] tw-px-[15px] tw-py-[7px] tw-rounded-[4px] tw-text-black tw-mb-[15px] tw-mt-[40px]`}
        >
          <InfoIcon className="tw-h-[20px] tw-mr-1 !tw-text-[18px]" />{" "}
          <span className="tw-font-medium tw-text-[14px] tw-ml-[4px] tw-leading-[20px]">
            Upload as many as {max_uploadable_files_limit} files for this
            request. Upload files up to {max_uploadable_file_size_in_mb}MB each.
          </span>
        </div>
      </div>
    </ExlyModal>
  );
};
